import TestimonialsSC, { TestimonialHolderSC, TestimonialSC } from "./testimonials.styles";

const TESTIMONIALS = [
    {
        rating: 5,
        text: [
            "My experience with Dr. Basavraja's counselling sessions were truly wonderful. " +
            "He is very kind, patient, and understanding. " +
            "From the very first session, I felt comfortable and safe sharing my thoughts and feelings. " +
            "He listened carefully without judging me and made sure I felt heard and respected. ",
            "Each session gave me more confidence and clarity. I felt supported throughout the process, and" +
            " it made a big difference in my emotional well-being. I am truly grateful for the care, understanding, " +
            "and helpful solutions provided during the counselling sessions."],
        name: "Suman",
        highlightText: '🌸 Comfortable Sessions',
        source: "Bengaluru",
        highlightColor: "#4c77ecff"
    },
    {
        rating: 5,
        text: [
            "I recently faced severe problems in my life where I got stuck and was unable to overcome it. " +
            "I decided to take professional help. I approached Dr. Basavraja. His expertise and structured " +
            "approach have proven to be invaluable assets in enhancing my overall wellbeing.",
            " In addition, his guidance equipped me with tools to better manage various aspects of my life. The sessions were truly " +
            "helpful in fostering positive changes and now I feel more empowered and capable of navigating through life's challenges.",
            "Dr. Basavraja's empathy, professionalism and skill full approach created a safe and " +
            "supportive space for open communication. Thank you so much. I highly recommend others to speak to him in " +
            "case you face any kind of ups and down in life."
        ],
        name: "Paulami",
        highlightText: '🧭 Navigating Life',
        source: "Bengaluru",
        highlightColor: "#4ad351ff"
    },
    {
        rating: 5,
        text: [
            "I am very greatful that I met you at the very tough phase of my life.",
            " You heard me like no other could do, in each counselling sessions. You have been guiding me since then and I am very faithful to you, " +
            "that you are in a part where I gathered strength to live.",
            " Thank you"
        ],
        name: "Hemalatha",
        highlightText: '🧸 Emotional Support',
        source: "Kanakapura",
        highlightColor: "#fc84b4ff"
    },
    {
        rating: 5,
        text: [
            "You created a safe and comfortable environment to share my mental issues" +
            " and you accurately understand the problem where exactly I was facing, you have listened very patiently. " +
            "I was interpreted while you are talking/suggesting something over all I’m believing I could solve my issues by your counselling...",
            " Thank you very much sir"
        ],
        name: "Tejasvi",
        highlightText: '🏡 Safe Space',
        source: "Chitradurga",
        highlightColor: "#7E57C2"
    }
];


const TestimonialCard = ({ highlightText, text, name, source, highlightColor }) => {
    return (
        <div className="testimonial-card">

            <div className="highlight-text" style={{ backgroundColor: highlightColor }}>
                {highlightText}
            </div>

            {
                text.map((item, index) => <p className="testimonial-text" key={index}>{item}</p>)
            }
            <p className="testimonial-author">
                {name} <span>{source}</span>
            </p>

        </div>
    )
}

const Testimonials = ({ ref }) => {
    return <TestimonialsSC>
        <div className="testimonial-title" ref={ref}>
            TESTIMONIALS
        </div>
        <div className="testimonial-holder">
            {TESTIMONIALS.map(content => <TestimonialCard {...content} />)}
        </div>

    </TestimonialsSC>
}

export default Testimonials;